import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlakyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flaky"}/>
}
